import { useNavigate } from 'react-router';
import { cn } from '@/utils';
import { getProbabilityEventNewsfeedPath } from '../../utils/event.utils';
import { useNewsfeedDigest } from '../../hooks/use-newsfeed-digest.hook';
import NewsfeedDigestBotIcon from '../../assets/icons/newsfeed-digest-bot.svg?react';

interface NewsfeedDigestButtonProps {
	eventId: string;
	className?: string;
}

export function NewsfeedDigestButton({ eventId, className }: NewsfeedDigestButtonProps) {
	const navigate = useNavigate();
	const { hasArticles, isUnread, markSeen } = useNewsfeedDigest(eventId);

	if (!hasArticles) return null;

	const handleClick = () => {
		markSeen();
		navigate(getProbabilityEventNewsfeedPath(eventId));
	};

	return (
		<div className={cn('relative size-8 shrink-0', className)}>
			{isUnread && (
				<span
					className="icon-pulse-ring pointer-events-none absolute inset-0 rounded-lg border-[0.5px] border-[#5583F6]"
					aria-hidden="true"
				/>
			)}
			<button
				type="button"
				onClick={handleClick}
				className="relative flex size-8 items-center justify-center rounded-lg border-[0.5px] border-[#DCE3F9] bg-white shadow-[0_1px_2px_rgba(12,12,13,0.05)] transition-colors hover:bg-[#F8FAFC] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2667FF]"
				aria-label="Open Bot Digest"
			>
				<NewsfeedDigestBotIcon className="size-4 shrink-0" aria-hidden="true" />
			</button>
		</div>
	);
}
